import { render, staticRenderFns } from "./GeneralLedgerStructure.vue?vue&type=template&id=18dd3c6d&scoped=true&"
import script from "./GeneralLedgerStructure.vue?vue&type=script&lang=js&"
export * from "./GeneralLedgerStructure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18dd3c6d",
  null
  
)

export default component.exports